import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { SpecificationEmbodimentOutlineModel, SpecificationEmbodimentOutlineState } from '../specification-embodiment-outline-model';

@injectable()
export class SpecificationEmbodimentOutlineModelImpl extends AbstractModel<SpecificationEmbodimentOutlineState> implements SpecificationEmbodimentOutlineModel {
    protected _modelData: SpecificationEmbodimentOutlineState = {
        outlines: [],
        summary: undefined,
        conclusion: undefined,
        loading: true,
        disabled: false,
    };
}
